define("ember-cp-validations/utils/meta-data", ["exports", "@ember/-internals/meta"], function (_exports, _meta) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  let id = 0;
  const dataKey = symbol('data');
  function symbol(key) {
    return `_${key}_${new Date().getTime()}_${id++}`;
  }
  function getData(obj, s) {
    let m = (0, _meta.meta)(obj);
    let data = m[dataKey];
    if (data) {
      return data[s];
    }
  }
  function setData(obj, s, value) {
    let m = (0, _meta.meta)(obj);
    let data = m[dataKey] = m[dataKey] || {};
    data[s] = value;
  }
  var _default = _exports.default = {
    symbol,
    getData,
    setData
  };
});